import isEmptyObject from './type-checks/isEmptyObject.js'
import isFunction from './type-checks/isFunction.js'
import isObject from './type-checks/isObject.js'
import track from './track.js'

const { isArray } = Array

/**
 * Similar to `Array.prototype.forEach`, but supports native
 * loop functionality via returning `break` or `continue`
 *
 * @param {Array|Object} collection
 * @param {Function} iterator
 *
 * @example
 * import { each } from '@cwp/utils'
 *
 * each(['foo', 'bar', 'baz'], (item, index, parentArray) => {
 *   if (item === 'foo') {
 *     return 'continue'
 *   } else if (item === 'bar') {
 *     return 'break'
 *   }
 * })
 *
 * each({ foo: 'bar'}, (key, value, parentObject) => {
 *   //...
 * })
 */
export default function each (collection, iterator) {
  // invalid iterator
  if (!isFunction(iterator)) {
    track.warn('invalid `each` iterator', iterator)
  } else if (isArray(collection)) {
    if (collection.length) {
      for (let i = 0; i < collection.length; i++) {
        let result = iterator(collection[i], i, collection)

        if (result === 'continue') continue
        if (result === 'break') break
      }
    }
  } else if (isObject(collection)) {
    if (!isEmptyObject(collection)) {
      for (let key in collection) {
        if (!collection.hasOwnProperty(key)) continue

        let result = iterator(key, collection[key], collection)

        if (result === 'continue') continue
        else if (result === 'break') break
      }
    }
  } else {
    track.warn('invalid `each` collection', collection)
  }
}
